export function makeId () {
  const randomPart = Math.random().toString(36).substring(2, 15);
  const timePart = new Date().getTime().toString(36);

  return randomPart + timePart;
}
